export class Tenant {
  tenantId: number;
  name: string;
  enabled: number;
}
